module.exports = __webpack_public_path__ + "img/logo.a5369aa3.svg";